import { styled } from '@mui/material';

// Contexts
import { withTranslate } from '../../../../core/TenantProvider';
//Assets 
import { ReactComponent as NoDataIcon } from '../assets/no-search-data.svg';
// Types
import { TypographyStyleObject } from '../../../../core/types/TypographyTypes';
import { HexColour } from '../../../../core/types/ThemeConfigTypes';
// Utils
import { getBody2MediumStyles, getBodySmallNormalStyles } from '../../../../core/utils/GetTypographyStyles/GetTypographyStyles';



const StyledGridOverlay = styled('div')(({ theme }) => {
    const {
        colours: {
            backgrounds: { background },
            text: { text }
        },
    } = theme;

    const BACKGROUND_COLOR: HexColour = background;
    const TEXT_COLOR: HexColour = text;
    const BODY_SMALL_NORMAL_TEXT: TypographyStyleObject = getBodySmallNormalStyles(theme);

    return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        backgroundColor: BACKGROUND_COLOR,
        ...BODY_SMALL_NORMAL_TEXT,
        color: TEXT_COLOR
    }
});

const IconContainer = styled('div')({
    marginBottom: 20
});

const StyledHeader = styled('div')(({ theme }) => {
    return {
        ...getBody2MediumStyles(theme),
        color: '#0A0A0A',
        marginBottom: 8
    }
});

const APDataTableNoSearchDataOverlay = (props): React.JSX.Element => {
    const { translate } = props;

    const noDataAvailableLabel: string = translate('clientmanagement.table.no.data');

    return (
        <StyledGridOverlay>
            <IconContainer>
                <NoDataIcon />
            </IconContainer>
            <StyledHeader>{noDataAvailableLabel}</StyledHeader>
        </StyledGridOverlay>
    );
}

export default withTranslate(APDataTableNoSearchDataOverlay);